export default __webpack_public_path__ + "static/media/thumbnail.401aee87.png";